export default __webpack_public_path__ + "43114fcfeff330d7116302d1d92e9869.png";